<template>
  <div class="eds-comp-language">
    <!-- 下拉菜单  -->
    <v-menu v-model="menu" offset-y nudge-bottom="5">
      <template v-slot:activator="{ on }">
        <v-btn class="position-btn square-btn" @click="menu = !menu">
          <img src="@/assets/svg/language.svg" alt="icon" width="30" height="30" />
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-tile @click="onUseZh()">
            <v-list-tile-title :style="isZh ? 'color:gray' : 'color:black'">中文</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="onUseEn()">
            <v-list-tile-title :style="isZh ? 'color: black' : 'color:gray'">English</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>


<script>
import dbHelper from '../util/db'
import msgbus from '../msgBus'
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'


export default {
  name: 'eDSCompLanguage',
  components: {},
  props: {
    wholeRefresh: { // 标识是否全刷新页面（暂无效）
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    info: {
      type: Object,
      default: null,
    },
    callbackFunction: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      menu: false, // 控制菜单的显示与隐藏
    }
  },
  computed: {
    ...mapGetters('app', [
      'displayName'
    ]),    
    isZh() {
      return this.$i18n.locale == 'zh'
    },
  },
  watch: {
  },
  methods: {
    onUseZh() {
      this.setLanguage('zh')
    },
    onUseEn() {
      this.setLanguage('en')
    },

    // 设置语言
    setLanguage(language){
      this.$i18n.locale = language
      msgbus.vm.setLanguage(language)
      dbHelper.set('language', language)

      // 切换浏览器标题栏的标题
      document.title = this.$i18n.t(this.displayName)

      // 说明：当前各页面显示的时候都会进行当前页的多语言翻译，因此后续代码不需要（注：若采用全刷新，手机上app会出现页面卡死现象）
      // 通知页面刷新
      // if (this.wholeRefresh) {
      //   window.location.href = '/' // / 是根路径，通常指向网站的首页 会触发整个页面的刷新 注：采用该语句，手机上app会出现页面卡死现象
      // } else {
      //   // 创建刷新消息
      //   window.postMessage('eds-message-refresh', '*')
      // }
    }
  },
  mounted() { },
  created() {
    if (process.env.NODE_ENV === 'development') {
      console.log('调试代码')
    }
  },
}
</script>


<style lang="scss">
.eds-comp-language {
  .position-btn {
    position: absolute;
    float: right;
    right: 20px;
    margin-top: 20px;
  }

  .square-btn {
    border-radius: 1 !important; // 去掉圆角
    padding: 1 !important; // 去掉内边距 
    min-width: 30px !important; // 设置最小宽度 
    width: 30px !important; // 设置宽度
    height: 30px !important; // 设置高度
  }
}
</style>